import React, { useEffect } from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import HeroSection from '../components/sections/HeroSection';
import SystemsSection from '../components/sections/SystemsSection';
import DistributorCTA from '../components/sections/DistributorCTA';
import SEOHead from '../components/seo/SEOHead';
import { trackPageView } from '../utils/analytics';

const HomePage = () => {
  useEffect(() => {
    trackPageView('Home');
  }, []);

  return (
    <>
      <SEOHead
        title="XION Medical Philippines - See More Than Others"
        description="XION Medical endoscopy systems in the Philippines. German-engineered visualization, endoscopes, and surgical equipment. Exclusive distributor: FMSInc."
        path="/"
      />
      <Header />
      <main>
        <HeroSection />
        <SystemsSection />
        <DistributorCTA />
      </main>
      <Footer />
    </>
  );
};

export default HomePage;
